/* eslint-disable react/prop-types */
import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

import button from './pngfind.com-cross-png-609333.png'
import './transformation.css'

const ProcessBar = ({ process, del, downloading, setDownloading, index, remove, hide, fetchApi }) => {
  async function download () {
    if (!downloading.current) {
      setDownloading(true)

      const count = process.data.imageCount || 1
      const results = process.data.result || ['result.jpg']
      let downloaded = 0
      let hasError = false

      for (let i = 0; i < count; i++) {
        const name = results[i] || `transformed_${i + 1}.jpg`
        const link = document.createElement('a')
        link.style.display = 'none'
        try {
          const res = await fetchApi('/api/static/transformedimage', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ data: { storage: process.data.storage_id, file: name, key: process.key } })
          })

          if (res && res.ok) {
            const disposition = res.headers.get('Content-Disposition')
            let filename = name
            if (disposition && disposition.indexOf('filename=') !== -1) {
              const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition)
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, '')
              }
            }
            const blob = await res.blob()
            const objectURL = URL.createObjectURL(blob)
            link.setAttribute('href', objectURL)
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            setTimeout(() => URL.revokeObjectURL(objectURL), 10000)
            downloaded++
          } else {
            console.error('Download failed with status:', res ? res.status : 'unknown')
            hasError = true
          }
        } catch (err) {
          console.error('Download error:', err)
          hasError = true
        }
      }

      setDownloading(false)
      if (downloaded >= count || (downloaded > 0 && !hasError)) {
        if (typeof remove === 'function') {
          remove(process.key)
        }
        if (typeof del === 'function') {
          del(process.key)
        }
      } else if (hasError && downloaded === 0) {
        alert('Could not download file. You can dismiss this task using the (X) button.')
      }
    } else {
      alert("You can't download when you are already downloading")
    }
  }

  const ref = useRef()
  useEffect(() => {
    ref.current.scrollIntoView({ behavior: 'smooth' })
  }, [])

  const deletionButton = <button className="deleteButton" style={{ background: 'transparent', position: 'absolute', right: '20px' }} onClick={() => { del(process.key) }} ><img src={button} height="20px" width="20px"></img></button>
  let processDisplay = ''
  const status = (process.data.status || '').toUpperCase()
  if (status === 'PENDING' || status === 'QUEUED') {
    processDisplay = (
    <div style={{ width: '100%' }} className="border border-warning procborder">
      Queued {process.data.imageCount} image{process.data.imageCount > 1 ? 's' : ''} to be processed with style: {process.data.style}. Process id: {process.key}
    </div>
    )
  } else if (status === 'STARTED' || status === 'PROCESSING' || status === 'IN_PROGRESS' || status === 'RUNNING') {
    processDisplay = (
    <div className="border border-primary procborder" style={{ width: '100%' }}>
      Processing {process.data.imageCount} image{process.data.imageCount > 1 ? 's' : ''} with style: {process.data.style}. Process id: {process.key}
    </div>
    )
  } else if (status === 'FINALIZING') {
    processDisplay = (
    <div className="border border-info procborder" style={{ width: '100%' }}>
      Finalizing {process.data.imageCount} image{process.data.imageCount > 1 ? 's' : ''} with style: {process.data.style}. Process id: {process.key}
    </div>
    )
  } else if (status === 'FAILURE' || status === 'FAILED' || status === 'FAILED_UPLOAD') {
    processDisplay = (
      <div className="border border-danger procborder" style={{ width: '100%', position: 'relative' }}>
        Process {process.key} failed.
        {deletionButton}
      </div>
    )
  } else if (status === 'SUCCESS' || status === 'COMPLETED') {
    processDisplay = (
      <div className="border border-success procborder" style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 15px', position: 'relative' }}>
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" />
        <span>Processed {process.data.imageCount} image{process.data.imageCount > 1 ? 's' : ''} with style: {process.data.style}</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <button className="btn btn-success" onClick={download}><i className="fa fa-download d-inline"></i> Download</button>
          <button
            className="deleteButton"
            title="Remove completed task"
            style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: '0 5px' }}
            onClick={() => {
              if (typeof remove === 'function') remove(process.key)
              if (typeof del === 'function') del(process.key)
            }}
          >
            <img src={button} height="18px" width="18px" alt="Dismiss" />
          </button>
        </div>
      </div>
    )
  } else {
    // Default fallback so bar never disappears during transitional states
    processDisplay = (
    <div className="border border-primary procborder" style={{ width: '100%' }}>
      Processing {process.data.imageCount || 1} image{(process.data.imageCount || 1) > 1 ? 's' : ''} with style: {process.data.style || 'style'}. Process id: {process.key}
    </div>
    )
  }
  return (
        <div ref={ref} className={`barcontainer ${hide ? 'hide' : ''}`}>
          {processDisplay}
        </div>
  )
}

ProcessBar.propTypes = {
  process: PropTypes.object
}

export default React.memo(ProcessBar)
